var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{attrs:{"text":"Basic link","primary":true,"appearance":"basic-link"}})
}
var staticRenderFns = []

export { render, staticRenderFns }